import Vue from 'vue'
import Vuex from 'vuex'
import main from './modules/main'

Vue.use(Vuex)

const DEBUG = process.env.NODE_ENV === 'development'

export default new Vuex.Store({
  modules: {
    main
  },
  strict: DEBUG
})



// WEBPACK FOOTER //
// ./src/store/index.js